var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-popover',{attrs:{"placement":"left","width":"200","trigger":"hover"}},[_c('div',{staticClass:"a-flex-cfsc"},[_c('div',{staticClass:"dev-qrcode",attrs:{"id":_vm.id}}),_vm._t("default")],2),_c('span',{attrs:{"slot":"reference"},slot:"reference"},[_vm._v(_vm._s(_vm.qrVal))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }